<script>
  import service from '../../../../domain/leiloes/services'
  import SelectTipoBemOption from './SelectTipoBemRenderOption'
  export default{
    name: 'select-tipo-bem',
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        loadError: false,
        isLoading: false,
        tipos: null
      }
    },
    computed: {
      model: {
        get () {
          return this.value === null ? '' : this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    mounted () {
      this.load()
    },
    destroyed () {
    },
    methods: {
      load () {
        this.isLoading = true
        service.buscaTiposBem().then((response) => {
          this.isLoading = false
          this.tipos = response.data.tipos
        })
          .catch((response) => {
            this.isLoading = false
            window.responseError(response)
            console.log(response)
          })
      },
      change (v) {
        this.$emit('atualizaCamposTipoBem', v.target.value)
      }
    },
    components: {SelectTipoBemOption}
  }
</script>

<template>
  <div>
    <select v-model="model" @change="change" class="form-control w-auto w-full-xs">
      <option disabled value="">{{ isLoading ? 'Carregando' : 'Selecione' }}</option>
      <select-tipo-bem-option v-for="tipo in tipos" :tipo="tipo" :key="tipo.id"></select-tipo-bem-option>
    </select>
    <a v-if="loadError" class="btn text-danger" @click="load">Não foi possível carregar. Tente novamente</a>
  </div>
</template>



// WEBPACK FOOTER //
// SelectTipoBem.vue?5ef74209